// Human-readable label for a user's role. The API returns the enum name
// (`ExecutiveAssistant`, `TenantAdmin`); single-word roles already read
// fine, and anything unrecognised passes through unchanged.
export function roleLabel(role: string | null | undefined): string {
  switch (role) {
    case 'ExecutiveAssistant': return 'Executive Assistant';
    case 'TenantAdmin': return 'Tenant Admin';
    case 'PlatformAdmin': return 'Platform Admin';
    default: return role ?? '';
  }
}
